import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationMaxAccountPage} from 'features/deposit/onboarding/pages/DepositApplicationMaxAccountPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/max-account',
)({
  component: DepositApplicationMaxAccountPage,
  validateSearch: (search) => {
    return {
      productCode: search.productCode as string | undefined,
    };
  },
});
